import { render, staticRenderFns } from "./PopupApertura.vue?vue&type=template&id=0127c803&scoped=true"
import script from "./PopupApertura.vue?vue&type=script&lang=js"
export * from "./PopupApertura.vue?vue&type=script&lang=js"
import style0 from "./PopupApertura.vue?vue&type=style&index=0&id=0127c803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0127c803",
  null
  
)

export default component.exports